import { appendLocaleSources } from '../../hooks/useTranslate'
import RolePresenter from '../../api/rolePresenter'

appendLocaleSources({
  [RolePresenter.urn]: {
    page: {
      title: 'Роли',
    },
    modal: {
      title: {
        create: 'Создание роли',
        update: 'Обновление роли',
      },
    },
    action: {
      create: 'Добавить роль',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить эту роль?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [RolePresenter.urn]: {
    page: {
      title: 'Roles',
    },
    modal: {
      title: {
        create: 'Create Role',
        update: 'Update Role',
      },
    },
    action: {
      create: 'Add Role',
    },
    message: {
      confirmDelete: `Are you sure you want to delete this role?`,
    },
  },
}, 'en')

appendLocaleSources({
  [RolePresenter.urn]: {
    page: {
      title: 'Rollar',
    },
    modal: {
      title: {
        create: 'Rollarni yaratish',
        update: 'Rollarni yangilash',
      },
    },
    action: {
      create: 'Rol qoshish',
    },
    message: {
      confirmDelete: `Ushbu rolni o'chirishni xohlaysizmi?`,
    },
  },
}, 'uz')


